import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';
import { FiLock, FiUnlock } from 'react-icons/fi';

// "Page Unlocked" / "Page Locked" control shown above each page of the
// spread. Clicking it toggles via the lock/unlock endpoints (usePageLock);
// the UI only flips once the request actually succeeds.
const PageLockToggle = ({ isLocked, isLoading, onToggle }) => (
  <Flex
    onClick={isLoading ? undefined : onToggle}
    alignItems="center"
    sx={{ gap: '6px', cursor: isLoading ? 'wait' : 'pointer', opacity: isLoading ? 0.6 : 1 }}
    bg="#fff"
    px={2}
    py={1}
    css="border-radius: 20px;    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;"
  >
    {isLocked ? <FiLock size={14} color="#0E0E0E" /> : <FiUnlock size={14} color="#0E0E0E" />}
    <Text fontFamily="Poppins" fontWeight={500} fontSize="13px" color="#0E0E0E">
      {isLocked ? 'Page Locked' : 'Page Unlocked'}
    </Text>
  </Flex>
);

PageLockToggle.propTypes = {
  isLocked: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

PageLockToggle.defaultProps = {
  isLoading: false,
};

export default PageLockToggle;
